<template>
  <div>
    <h2 class="text-center mt-0 pt-4" style="border-bottom: 2px solid;">Content</h2>
    <h3 class="content-heading pl-4">Hours</h3>
    <div class="row pl-5">
      <div class="col-md-2 col-11">
        <input type="text" class="form-control" v-model="openingTime" placeholder="00:00">
      </div>-
      <div class="col-md-2 col-11 contentPaddingClass">
        <input type="text" class="form-control" v-model="closingTime" placeholder="00:00">
      </div>
    </div>
    <!-- <h3 class="content-heading">Time Slot Applicable</h3>
    <div class="row pl-5">
      <div class="col-md-2 col-11">
        <select v-model="timeSlotApplicable" class="form-control mb-3">
          <option value="" selected disabled>Choose value</option>
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>
    </div> -->
    <h3 class="content-heading pl-4">Latitude/Longitude</h3>
    <div class="row pl-5">
      <div class="col-md-3 col-11">
        <input type="text" class="form-control" v-model="latitude" placeholder="latitude">
      </div>
      <div class="col-md-3 col-11 contentPaddingClass">
        <input type="text" class="form-control" v-model="longitude" placeholder="longitude">
      </div>
    </div>
    <h3 class="content-heading pl-4" style="color: red;">Web Address *</h3>
    <div class="row pl-5">
      <div class="col-md-6 col-11">
        <input type="text" class="form-control" v-model="webAddress" placeholder="Web address">
      </div>
    </div>
    <h3 class="content-heading pl-4">Map</h3>
    <div class="row pl-5">
      <div class="col-md-11 col-11">
        <textarea class="form-control" v-model="mapIframe" placeholder="Map" cols="10" rows="5"></textarea>
      </div>
    </div>

    <div class="row content-heading">
      <div class="col-md-3 col-sm-12">
        <h3 class="mt-5 pl-4">Mission Statement</h3>
      </div>
      <div class="col-md-3 col-sm-12 mt-2">
        <label for="">Font Color</label>
        <input type="text" class="form-control" v-model="aboutTextColor" placeholder="#FFFFFF">
      </div>
      <div class="col-md-3 col-sm-12 my-2">
        <label for="">Background Color</label>
        <input type="text" class="form-control" v-model="aboutBackgroundColor" placeholder="Mission text color">
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-12 px-5">
        <input type="color" @input="applyColor($event)" />
        <vue-editor id="aboutUs" @focus="setActiveEditor(1)" ref="editor-1" v-model="aboutUs" />
      </div>
    </div>
    <div class="row content-heading">
      <div class="col-md-4 col-sm-12">
        <h3 class="mt-5 pl-4">Welcome Message</h3>
      </div>
      <div class="col-md-3 col-sm-12 mt-2">
        <label for="">Font Color</label>
        <input type="text" class="form-control" v-model="welcomeTextColor" placeholder="#FFFFFF">
      </div>
      <div class="col-md-3 col-sm-12 my-2">
        <label for="">Background Color</label>
        <input type="text" class="form-control" v-model="welcomeBackgroundColor" placeholder="#FFFFFF">
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 px-5">
        <input type="color" @input="applyColor($event)" />
        <vue-editor @focus="setActiveEditor(2)" ref="editor-2" v-model="welcomeTxt" />
      </div>
    </div>
    <h3 class="content-heading mt-5 pl-4">Privacy Policy</h3>
    <div class="row">
      <div class="col-md-12 px-5">
        <input type="color" @input="applyColor($event)" />
        <vue-editor @focus="setActiveEditor(3)" ref="editor-3"  v-model="privacyPolicy" />
      </div>
    </div>
    <h3 class="content-heading mt-5 pl-4">Terms & Condition</h3>
    <div class="row">
      <div class="col-md-12 px-5">
        <input type="color" @input="applyColor($event)" />
        <vue-editor @focus="setActiveEditor(4)" ref="editor-4"  v-model="termsCondition" />
      </div>
    </div>
    <h3 class="content-heading mt-5 pl-4">Allergy Information</h3>
    <div class="row">
      <div class="col-md-12 px-5">
        <input type="color" @input="applyColor($event)" />
        <vue-editor @focus="setActiveEditor(5)" ref="editor-5"  v-model="allergyInformation" />
      </div>
    </div>
    <h3 class="content-heading mt-5 pl-4">Lunch Opening Hours</h3>
    <div class="row">
      <div class="col-md-12 px-5">
        <vue-editor v-model="lunchOpeningHours" />
      </div>
    </div>
    <h3 class="content-heading mt-5 pl-4">Review Title</h3>
    <div class="row">
      <div class="col-md-12 px-5">
        <input type="text" class="form-control" v-model="customerReviewTitle" placeholder="Customer Review">
      </div>
    </div>
    <h3 class="content-heading mt-5 pl-4">Dojo Booking Link</h3>
    <div class="row">
      <div class="col-md-12 px-5">
        <input type="text" class="form-control" v-model="dojoBookingLink" placeholder="Dojo Booking Link">
      </div>
    </div>
    <h3 class="content-heading mt-5 pl-4">Dojo Enquiry Link</h3>
    <div class="row">
      <div class="col-md-12 px-5">
        <input type="text" class="form-control" v-model="dojoEnquiryLink" placeholder="Dojo Enquiry Link">
      </div>
    </div>
    <h3 class="content-heading mt-5 pl-4">Quandoo Merchant Id</h3>
    <div class="row">
      <div class="col-md-12 px-5">
        <input type="text" class="form-control" v-model="quandooMerchantId" placeholder="Quandoo Merchant Id">
      </div>
    </div>
    <h3 class="content-heading mt-5 pl-4">Home Button Link</h3>
    <div class="row">
      <div class="col-md-12 px-5">
        <input type="text" class="form-control" v-model="homeButtonLink" placeholder="Home Button Link">
      </div>
    </div>
    <div class="col-md-12 p-5 contentBtnAlign">
      <button class="btn submitBtn" @click="updateWebConfig">Upload</button>
      <img v-if="showWebConfigLoading" src="/img/loading.gif" alt="GIF" width="30" height="30">
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { mapMutations } from 'vuex'

export default {
  props: [
    'webConfig',
    'requestHeader',
  ],
  data() {
    return {
      openingTime: '',
      closingTime: '',
      timeSlotApplicable: '',
      latitude: '',
      longitude: '',
      webAddress: '',
      mapIframe: '',
      aboutUs: '',
      aboutTextColor: '',
      aboutBackgroundColor: '',
      welcomeTxt: '',
      welcomeTextColor: '',
      welcomeBackgroundColor: '',
      privacyPolicy: '',
      termsCondition: '',
      allergyInformation: '',
      lunchOpeningHours: '',
      customerReviewTitle: '',
      dojoBookingLink: '',
      dojoEnquiryLink: '',
      quandooMerchantId: '',
      homeButtonLink: '',
      showWebConfigLoading: false,
      activeEditor: null,
    }
  },
  mounted() {
    this.openingTime = this.webConfig.openingTime
    this.closingTime = this.webConfig.closingTime
    this.timeSlotApplicable = this.webConfig.timeSlotApplicable
    this.latitude = this.webConfig.lat
    this.longitude = this.webConfig.long
    this.webAddress = this.webConfig.webAddress
    this.mapIframe = this.webConfig.mapIframe
    this.aboutUs = this.webConfig.aboutUs
    this.aboutTextColor = this.webConfig.aboutTextColor
    this.aboutBackgroundColor = this.webConfig.aboutBackgroundColor
    this.welcomeTxt = this.webConfig.welcomeTxt
    this.welcomeTextColor = this.webConfig.welcomeTextColor
    this.welcomeBackgroundColor = this.webConfig.welcomeBackgroundColor
    this.privacyPolicy = this.webConfig.privacyPolicy
    this.termsCondition = this.webConfig.termsCondition
    this.allergyInformation = this.webConfig.allergyInformation
    this.lunchOpeningHours = this.webConfig.lunchOpeningHours
    this.customerReviewTitle = typeof this.webConfig.customerReviewTitle == 'undefined' ? '' : this.webConfig.customerReviewTitle
    this.dojoBookingLink = typeof this.webConfig.dojoBookingLink == 'undefined' ? '' : this.webConfig.dojoBookingLink
    this.dojoEnquiryLink = typeof this.webConfig.dojoEnquiryLink == 'undefined' ? '' : this.webConfig.dojoEnquiryLink
    this.quandooMerchantId = typeof this.webConfig.quandooMerchantId == 'undefined' ? '' : this.webConfig.quandooMerchantId
    this.homeButtonLink = typeof this.webConfig.homeButtonLink == 'undefined' ? '' : this.webConfig.homeButtonLink
  },
  methods: {
    ...mapMutations(['setRestaurantWebConfig']),
    setActiveEditor(index) {
      this.activeEditor = index;
    },
    applyColor(event) {
      const color = event.target.value;

      if (this.activeEditor === null) return;

      const quill = this.$refs["editor-" + this.activeEditor].quill;
      const range = quill.getSelection();

      if (range) {
        quill.format("color", color);
      }
    },
    updateWebConfig(){
      if (this.webAddress == '') {
        this.$toastr.w("Please enter web address.", "Warning");
        return
      }
      this.showWebConfigLoading = true
      let dataToSubmit = this.webConfig
      dataToSubmit.welcomeTxt = this.welcomeTxt
      dataToSubmit.aboutUs = this.aboutUs
      dataToSubmit.privacyPolicy = this.privacyPolicy
      dataToSubmit.termsCondition = this.termsCondition
      dataToSubmit.lat = this.latitude
      dataToSubmit.long = this.longitude
      dataToSubmit.mapIframe = this.mapIframe
      dataToSubmit.welcomeTextColor = this.welcomeTextColor
      dataToSubmit.welcomeBackgroundColor = this.welcomeBackgroundColor
      dataToSubmit.aboutTextColor = this.aboutTextColor
      dataToSubmit.aboutBackgroundColor = this.aboutBackgroundColor
      dataToSubmit.openingTime = this.openingTime
      dataToSubmit.closingTime = this.closingTime
      dataToSubmit.allergyInformation = this.allergyInformation
      dataToSubmit.lunchOpeningHours = this.lunchOpeningHours
      dataToSubmit.customerReviewTitle = this.customerReviewTitle
      dataToSubmit.dojoBookingLink = this.dojoBookingLink
      dataToSubmit.dojoEnquiryLink = this.dojoEnquiryLink
      dataToSubmit.quandooMerchantId = this.quandooMerchantId
      dataToSubmit.homeButtonLink = this.homeButtonLink
      dataToSubmit.webAddress = this.webAddress

      let url = process.env.VUE_APP_API_URL+'/api/webConfig/update'

      axios
        .post(url, dataToSubmit, {
          headers: this.requestHeader
        })
        .then((data) => {
          if (data.status == 200) {
            this.showWebConfigLoading = false
            this.$toastr.s("Successfully Updated.", "Success");
            this.setRestaurantWebConfig(data.data)
          }
        })
    },
  }
}
</script>
